import React from 'react';
import ReactDOM from 'react-dom/client';
// Import CssBaseline from Material UI
import { CssBaseline } from '@mui/material';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* This single line removes the default browser margin/padding globally */}
    <CssBaseline />
    <App />
  </React.StrictMode>,
);
